<h3>CIFRIS CHAIN</h3>
<p> L'iniziativa Cifris Chain raccoglie i membri della De Cifris
	interessati agli aspetti crittografici della tecnologia blockchain
	e del concetto di cryptocurrency.</p>
<p> L'obiettivo è creare una sinergia tra le diverse competenze in
	De Cifris per contribuire sia agli aspetti di divulgazione e
	formazione, sia agli aspetti di ricerca e trasferimento tecnologico. </p>
<p> Per aderire all'iniziativa contattare <a href="mailto:cifrischain@decifris.it">cifrischain&#64;decifris.it</a>. <br>

<h4>SEMINARI RECENTI</h4>
<ul>

</ul>

<h4>PROSSIMI SEMINARI</h4>
<ul>

</ul>
<h4>SEMINARI PASSATI</h4>
<ul>
	<li>
		<b> 19 Gennaio 2022 -- 15:00 </b>
		<ul>
			<li>
				<b>Fadi Barbara</b> -- Università di Torino <br>
				<i>"Digital signature for interoperability and privacy in
					blockchains"</i><br>
				<a href=".././../../assets/attivita/gruppi/cifrisChain/
								FadiBarbara.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/cifrisChain/Allegato1_
								CifrisChain_SLIDE_Barbara.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=6RU7xDmz7Ok">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>5 Ottobre 2021</b> <b> - 15:00</b>
		<ul>
			<li>
				<b>Luca Nizzardo</b> -- Protocol Labs <br>
				<i>"Filecoin: From Proof of Space to Decentralised Storage"</i><br>
				<a href="../../../assets/attivita/gruppi/cifrisChain/LucaNizzardoLocandina.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/cifrisChain/Filecoin_Luca_CifrisChain 2021Slide.pdf">Slide</a>
				--
				<a href="https://mega.nz/file/rJcTgC4a#nn79u9pbp4WRq7xiG0-AGjjCHw17qvWbR9KJEvdj5C8">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>22 Aprile 2021 - 10:00</b>
		<ul>
			<li>
				<b>Simone Cortese</b> -- Product Manager & Visiting Lecturer <br>
				<i>"Blockchain, Applicazioni Finanziarie, Soluzioni Crittografiche
					privacy-preserving e i requisiti dei consumatore"</i>.<br>
				<a href="../../../assets/attivita/gruppi/cifrisChain/Cortese.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/cifrisChain/CorteseSlide.pdf">Slide</a> --
				<a href="https://youtu.be/sbgbtmM6wSY">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>15 Dicembre 2020</b>
		<ul>
			<li>
				<b>Michele Ciampi</b> -- University of Edimburgh <br>
				<i>"Updatable Blockchains"</i>. <br>
				<a href="../../../assets/attivita/gruppi/cifrisChain/Locandina_
							Ciampi.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/cifrisChain/CChain_Casati.
							pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=bocHCy-CUZE&ab_channel=
							DeComponendisCifris">Video</a> <br>
			</li>
		</ul>
	</li>
	<li><b>13 Novembre 2020</b>
		<ul>
			<li>
				<b>Egidio Casati</b> --
				<a>NYM</a>
				<br>
				<i>eIDAS e tecnologie per la decentralizzazione: l'esperienza della blockchain Commercio Network</i>
				<br>
				<a href="../../../assets/attivita/gruppi/cifrisChain/Casati_locandina.pdf">Locandina</a> -
				<a href="../../../assets/attivita/gruppi/cifrisChain/CChain_Casati.pdf">Slide</a> -
				<a href="https://youtu.be/dSotL9bPDfg">Video</a>
			</li>
		</ul>
	</li>
	<li><b>19 Ottobre 2020</b>
		<ul>
			<li>
				<b>Angelo De Caro</b> --
				<a>IBM Research</a>
				<br>
				<i>Permissioned Blockchains: What, Why, How</i>
				<br>
				<a href="../../../assets/attivita/gruppi/cifrisChain/CifrisChain_
							DeCaro_19_ottobre_2020.pdf">Locandina</a> --
				<a href="https://youtu.be/bZ2T9LKCu68">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b>20 Luglio 2020</b>
		<ul>
			<li>
				<b>Domenica Sogiorno</b> --
				<a>Università di Bari</a>
				<br>
				<i>Una famiglia di chiavi deboli nel Bitcoin</i><br>
				<a href="../../../assets/attivita/gruppi/cifrisChain/Sogiorno_Locandina.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/cifrisChain/SogiornoSlide.pdf">Slide</a> --
				<a href="https://youtu.be/h-oSS8TKMLs">Video</a>
			</li>
		</ul>
	</li>
	<li><b>31 Maggio 2020</b>
		<ul>
			<li>
				<b>Chiara Spadafora</b> --
				<a>Università di Trento </a>
				<br>
				<i>A new blockchain-based secure e-voting protocol</i>
				<br>
				<a href="https://youtu.be/Lpn_u1ziLmQ">Video</a>
			</li>
		</ul>
	</li>
	<li><b>25 Maggio 2020</b>
		<ul>
			<li>
				<b>Andrea Gangemi</b> --
				<a>Politecnico di Torino</a>
				<br>
				<i>The links between Machine Learning and Blockchain</i>
				<br>
				<a href="https://youtu.be/KDvD5oCz0RY">Video</a>
			</li>
		</ul>
	</li>
	<li><b>5 Maggio 2020</b>
		<ul>
			<li>
				<b>Barbàra Fadi</b> --
				<a>Politecnico di Torino</a>
				<br>
				<i>The Blockchain Privacy Problem</i>
				<br>
				<a href="https://youtu.be/nPQJ7Cix77k">Video</a>
			</li>
		</ul>
	</li>
</ul>


<h4>EVENTI 2018-19</h4>
<ul>
	<li> Prima Hackaton De Cifris simultanea in quattro città:
		Milano, Roma, Torino e Trento: 26 settembre 2019; </li>
	<li> Secondo evento concluso con grandissima soddisfazione
		(trecento partecipanti!), tenuto presso la prestigiosa sede
		della CONSOB con enfasi su Fintech: 9 maggio 2019; </li>
	<li> Primo evento concluso con grande soddisfazione: 17 dicembre 2018. </li>
</ul>
<h4>VIDEO</h4>
<p>I video di crittografia relativi a questo argomento sono disponibili sul nostro <a href="https://www.youtube.com/
						watch?v=SSZLVCyueD0&list=PLu4yxTVzRRMVYZwb9ukJTkUyVN-6bQEsR">canale YouTube.</a></p>


<h4>PUBBLICAZIONI</h4>
<p> Suggerimenti e ulteriori elementi utili per un affinamento della strategia
	italiana in materia di tecnologie basate su registri condivisi e Blockchain
	-- <a href="../../../assets/attivita/gruppi/cifrisChain/Strategia
							Blockchain-CifrisChain2020.pdf">Link</a> -- Questo documento è
	composto da suggerimenti e ulteriori elementi
	utili per un affinamento della strategia italiana in materia di tecnologie
	basate su registri condivisi e blockchain, ed è stato redatto con il coordinamento
	del nostro Acting Director Massimiliano Sala e con il contributo dei professori: </p>
<ul>
	<li>Ivan Visconti </li>
	<li>Marco Baldi</li>
	<li>Norberto Gavioli</li>
	<li>Federico Pintore</li>
	<li>Giovanni Schmid</li>
	<li>Vincenzo Vespri</li>
	<li>Filippo Zatti</li>
</ul>

<!-- <div class="row">
				<div class="col-md-12">
					<p>Per leggere le proposte del Ministero dello sviluppo economico clicca qui. </p>
				</div>
			</div> -->